// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__30RVf","footer":"ChangeClinic_footer__1b57K"};